import { styled } from '@mui/material';

import { rem, m } from '@helpers/remUtils';

export const FlyoutPopupTabTitle = styled('h3')({
  margin: m(0, 0, 13),
  fontSize: rem(15),
  fontWeight: 700,
});
